import { apiClient } from '@/lib/api';
import axiosInstance from '@/lib/api/axios-instance';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { TenantSubscription, Pagination } from '../types/admin.types';

class SubscriptionsService {
  async getAll(params?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<{ data: TenantSubscription[]; pagination: Pagination }> {
    const query = new URLSearchParams();
    if (params?.status) query.set('status', params.status);
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    const url = `${ENDPOINTS.SUBSCRIPTIONS}?${query.toString()}`;
    const response = await axiosInstance.get(url);
    return { data: response.data.data, pagination: response.data.pagination };
  }

  async create(data: {
    tenantId: string;
    planId: string;
    endDate: string;
    isTrial?: boolean;
    notes?: string;
  }): Promise<TenantSubscription> {
    return apiClient.post<TenantSubscription>(ENDPOINTS.SUBSCRIPTIONS, data);
  }

  async update(id: string, data: Record<string, any>): Promise<TenantSubscription> {
    return apiClient.patch<TenantSubscription>(ENDPOINTS.SUBSCRIPTION_BY_ID(id), data);
  }

  async getByTenant(tenantId: string): Promise<TenantSubscription[]> {
    return apiClient.get<TenantSubscription[]>(ENDPOINTS.SUBSCRIPTION_BY_TENANT(tenantId));
  }

  async cancel(id: string, reason?: string): Promise<TenantSubscription> {
    return apiClient.post<TenantSubscription>(ENDPOINTS.SUBSCRIPTION_CANCEL(id), { reason });
  }
}

export const subscriptionsService = new SubscriptionsService();
